<template>
  <div id="Home">
    <Landing />
    <RenewalOffer/>
    <Renewing/>
    <Amenities />
    <BroncosPlus />
    <MapPricing />
    <RenewalDeadline />
    <Footer />
  </div>
</template>

<script>
  import Landing from "@/components/sections/Landing/Landing";
  import RenewalOffer from "@/components/sections/RenewalOffer/RenewalOffer";
  import Renewing from "@/components/sections/Renewing/Renewing";
  import Amenities from "@/components/sections/Amenities/Amenities";
  import BroncosPlus from "@/components/sections/BroncosPlus/BroncosPlus";
  import MapPricing from "@/components/sections/MapPricing/MapPricing";
  import RenewalDeadline from "@/components/sections/RenewalDeadline/RenewalDeadline";
  import Footer from "@/components/Layout/Footer";

  export default {
    name: "Home",
    components: {
      Landing,
      RenewalOffer,
      Renewing,
      Amenities,
      BroncosPlus,
      MapPricing,
      RenewalDeadline,
      Footer
    }
  }
</script>

<style lang="scss" scoped>
  
</style>